import * as React from 'react';

interface Props {
	cssUrl: string
}

class LoadCss extends React.Component<Props> {
	constructor(props: Props) {
		super(props);
	}

	public render() {
		return (<div></div>);
	}

	public componentDidMount() {
		var head  = document.getElementsByTagName('head')[0];
		var link  = document.createElement('link');
		link.rel  = 'stylesheet';
		link.type = 'text/css';
		link.href = this.props.cssUrl;
		link.media = 'all';
		head.appendChild(link);
	}
}

export default LoadCss;


// WEBPACK FOOTER //
// ./src/components/loadcss/index.tsx